
// Sobrescribo la función que usa JSON para parsear fechas
Date.prototype.toISOString = function () {
    return DateUtils.formatDateTime(this, false).replace(' ', 'T');
}

export class DateUtils {

    static formatDateTime(date: Date, humanReadable: boolean): string {
        let res = '';
        if (!humanReadable) {
            res = date.getFullYear().toString().padStart(4, '0') + '-';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '-';
            res = res + date.getDate().toString().padStart(2, '0') + ' ';
        } else {
            res = date.getDate().toString().padStart(2, '0') + '/';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '/';
            res = res + date.getFullYear().toString().padStart(4, '0') + ' ';
        }
        res = res + date.getHours().toString().padStart(2, '0') + ':';
        res = res + date.getMinutes().toString().padStart(2, '0') + ':';
        res = res + date.getSeconds().toString().padStart(2, '0');
        return res;
    }

    static formatDate(date: Date, humanReadable: boolean): string {
        let res = '';
        if (!humanReadable) {
            res = date.getFullYear().toString().padStart(4, '0') + '-';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '-';
            res = res + date.getDate().toString().padStart(2, '0') + ' ';
        } else {
            res = date.getDate().toString().padStart(2, '0') + '/';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '/';
            res = res + date.getFullYear().toString().padStart(4, '0') + ' ';
        }
        return res;
    }

    static formatDateTimeShort(date: Date, humanReadable: boolean): string {
        let res = '';
        if (!humanReadable) {
            res = (date.getFullYear() - 2000).toString().padStart(2, '0') + '-';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '-';
            res = res + date.getDate().toString().padStart(2, '0') + ' ';
        } else {
            res = date.getDate().toString().padStart(2, '0') + '/';
            res = res + (date.getMonth() + 1).toString().padStart(2, '0') + '/';
            res = res + (date.getFullYear() - 2000).toString().padStart(2, '0') + ' ';
        }
        res = res + date.getHours().toString().padStart(2, '0') + ':';
        res = res + date.getMinutes().toString().padStart(2, '0') + ':';
        res = res + date.getSeconds().toString().padStart(2, '0');
        return res;
    }

    static formatTime(date: Date): string {
        let res = date.getHours().toString().padStart(2, '0') + ':';
        res = res + date.getMinutes().toString().padStart(2, '0') + ':';
        res = res + date.getSeconds().toString().padStart(2, '0');
        return res;
    }

    static formatDateAMDhms(date: Date): string {
        let res = '';
        res = (date.getFullYear() - 2000).toString().padStart(2, '0');
        res = res + (date.getMonth() + 1).toString().padStart(2, '0');
        res = res + date.getDate().toString().padStart(2, '0');
        res = res + date.getHours().toString().padStart(2, '0');
        res = res + date.getMinutes().toString().padStart(2, '0');
        res = res + date.getSeconds().toString().padStart(2, '0');
        return res;
    }

    public static isValidDate(date: Date): boolean {
        if (!date) {
            return false;
        }
        const a = date.getFullYear();
        const m = date.getMonth();
        const d = date.getDate();
        if (date.getFullYear() < 1970 || date.getMonth() < 0 || date.getMonth() > 11 ||
            date.getDate() < 1 || date.getDate() > 31 || date.getHours() < 0 || date.getHours() > 23 ||
            date.getMinutes() < 0 || date.getMinutes() > 59 || date.getSeconds() < 0 || date.getSeconds() > 59)
            return false;
        return true;
    }

}